(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-studs-size-guide"] && !Shopify.designMode) return;
  try {
    
class ASStudsBuilder extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    const config = this.querySelector('[data-config]');
    this.form = this.querySelector('form');
    if (!config || !this.form) return;
    this.config = JSON.parse(config.textContent);
    this.variants = this.config.variants || [];
    if (!this.variants.length) return;
    this.initialized = true;
    this.trackHeader = () => {
      if (this.headerFrame) return;
      this.headerFrame = requestAnimationFrame(() => {
        this.headerFrame = null;
        const header = document.querySelector('header-component') || document.querySelector('#header-group') || document.querySelector('header');
        const bottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
        this.style.setProperty('--as-builder-sticky-top', Math.round(bottom) + 'px');

      });
    };
    window.addEventListener('scroll', this.trackHeader, {passive:true});
    window.addEventListener('resize', this.trackHeader);
    this.trackHeader();
    this.money = new Intl.NumberFormat(this.config.locale || 'en-US', {style:'currency',currency:this.config.currency || 'USD',maximumFractionDigits:0});
    this.sizes = Array.from(this.querySelectorAll('[data-choice="Total carat weight"]'));
    this.range = this.querySelector('[data-range]');
    this.buttons = Array.from(this.querySelectorAll('[data-purchase]'));
    this.buttons.forEach(button => { button.dataset.label = button.textContent; });
    const initial = this.variants.find(v => String(v.id) === String(this.config.selectedId));
    if (initial) ['Total carat weight','Diamond shape','Gold'].forEach((key,index) => this.select(key, initial.options[index]));
    this.querySelectorAll('[data-choice]').forEach(input => input.addEventListener('change', () => {
      this.update();

    }));
    this.range.addEventListener('input', () => {
      this.sizes[Number(this.range.value)].checked = true;
      this.update();
      this.showView('ear');
    });
    this.querySelectorAll('[data-view]').forEach(button => button.addEventListener('click', () => this.showView(button.dataset.view)));
    this.form.addEventListener('submit', event => this.purchase(event));
    this.update(true);
  }
  disconnectedCallback() {
    window.removeEventListener('scroll', this.trackHeader);
    window.removeEventListener('resize', this.trackHeader);
    if (this.headerFrame) cancelAnimationFrame(this.headerFrame);
  }
  select(key,value) {
    this.querySelectorAll('[data-choice]').forEach(input => { if (input.dataset.choice === key) input.checked = input.value === value; });
  }
  value(key) {
    return Array.from(this.querySelectorAll('[data-choice]:checked')).find(input => input.dataset.choice === key)?.value;
  }
  showView(view) {
    this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== view; });
    this.querySelectorAll('[data-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.view === view)));
    this.querySelector('[data-preview-note]').textContent = view === 'detail' ? this.config.labels.detailNote : this.config.labels.previewNote;
  }
  update(initial = false) {
    const size = this.value('Total carat weight');
    const shape = this.value('Diamond shape');
    const gold = this.value('Gold');
    const setting = this.value('Setting');
    const backing = this.value('Backing');
    const each = parseFloat(size) / 2;
    this.variant = this.variants.find(v => v.options[0] === size && v.options[1] === shape && v.options[2] === gold);
    this.querySelector('[data-variant]').value = this.variant?.id || '';
    const available = Boolean(this.variant && this.variant.available);
    this.buttons.forEach(button => { button.disabled = !available || this.busy; });
    this.querySelector('[data-price]').textContent = this.variant ? this.money.format(this.variant.price / 100) : '—';
    this.querySelector('[data-pair-weight]').textContent = size;
    this.querySelector('[data-each-weight]').textContent = each.toFixed(2) + ' ct';
    this.querySelector('[data-each-property]').value = each.toFixed(2) + ' ct';
    this.range.value = this.sizes.findIndex(input => input.checked);
    this.range.setAttribute('aria-valuetext', this.config.labels.sizeAria.replace('[pair]',parseFloat(size).toFixed(2)).replace('[each]',each.toFixed(2)).replace('[price]',this.querySelector('[data-price]').textContent));
    this.querySelector('[data-summary]').textContent = [size,shape,gold,setting,backing].join(' · ');
    const asset = shape === 'Round' && setting === 'Martini' ? this.config.assets.roundMartini : this.config.assets[shape];
    const metal = gold === '14K Yellow Gold' ? 1 : 0;
    const box = asset.boxes[metal];
    this.querySelectorAll('[data-sprite]').forEach(svg => {
      svg.setAttribute('viewBox', box.join(' '));
      svg.querySelector('image').setAttribute('href', asset.url);
    });
    const roundThumbAsset = setting === 'Martini' ? this.config.assets.roundMartini : this.config.assets.Round;
    const roundThumb = this.querySelector('[data-thumb="Round"]');
    roundThumb.setAttribute('viewBox', roundThumbAsset.boxes[metal].join(' '));
    roundThumb.querySelector('image').setAttribute('href', roundThumbAsset.url.replace('width=1000','width=256'));
    const earStud = this.querySelector('.as-builder__ear-stud');
    earStud.style.setProperty('--stud-width',(asset.mmWidth * Math.cbrt(each) * 11 / 1254 * 100).toFixed(4) + '%');
    earStud.style.setProperty('--stud-ratio',box[2] / box[3]);
    this.querySelector('[data-ear-label]').textContent = size + ' · ' + each.toFixed(2) + ' ct / stud · ' + shape;
    const original = initial && shape === 'Round' && metal === 0 && setting === 'Martini' && backing === 'Screw back';
    this.querySelector('[data-pair]').hidden = original;
    this.querySelector('[data-panel="front"] .as-builder__photo').hidden = !original;
    if (!original) this.querySelector('[data-front-label]').textContent = [shape,gold].join(' · ');
    const detail = this.querySelector('[data-detail]');
    detail.setAttribute('viewBox',[(backing === 'Push back' ? 627 : 0),(setting === 'Martini' ? metal * 627 : 627),627,627].join(' '));
    detail.querySelector('image').setAttribute('href',setting === 'Martini' ? this.config.assets.martiniDetails : this.config.assets.details[metal ? 'yellow' : 'white']);
    this.querySelector('[data-detail-label]').textContent = [gold,setting,backing].join(' · ');
    this.error(available ? '' : this.config.labels.unavailable);
  }
  error(message) {
    const error = this.querySelector('[data-error]');
    error.textContent = message;
    error.hidden = !message;
  }
  async purchase(event) {
    event.preventDefault();
    if (this.busy || !this.variant?.available) return;
    this.busy = true;
    const destination = event.submitter?.dataset.purchase === 'checkout' ? this.config.root + 'checkout' : this.config.cart;
    const data = new FormData(this.form);
    this.buttons.forEach(button => { button.disabled = true; });
    const clicked = event.submitter || this.buttons[0];
    clicked.textContent = this.config.labels.adding;
    this.error('');
    try {
      const response = await fetch(this.config.cartAdd + '.js', {method:'POST',body:data,headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || this.config.labels.error);
      window.location.assign(destination);
    } catch (error) {
      this.error(error.message || this.config.labels.error);
      this.busy = false;
      this.buttons.forEach(button => { button.disabled = !this.variant?.available; button.textContent = button.dataset.label; });
    }
  }
}
if (!customElements.get('as-studs-builder')) customElements.define('as-studs-builder', ASStudsBuilder);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
